import React from 'react';

type Props = {
  to: string;
};

const FORM_URLS = {
  BUY_ORDER: '/kopa-lagerbolag/pris',
  SELL_OFFER: '/avveckla-aktiebolag/pris',
};

export function SharedLink(props: Props) {
  if (props.to.includes(FORM_URLS.SELL_OFFER)) {
    return React.createElement('a', {
      ...props,
      href: [process.env.REACT_APP_GATSBY_SITE_LINK, props.to].join(''),
    });
  }

  if (props.to.includes(FORM_URLS.BUY_ORDER)) {
    return React.createElement('a', {
      ...props,
      href: [process.env.REACT_APP_GATSBY_SITE_LINK, props.to].join(''),
    });
  }

  if (props.to.includes('https://citadellet.konfident.io/')) {
    return React.createElement('a', {
      ...props,
      href: ['', props.to].join(''),
    });
  }

  return React.createElement('a', {
    ...props,
    href: [process.env.REACT_APP_GATSBY_SITE_LINK, props.to].join(''),
  });
}
